module.exports = "https://img.xiyuyouxi.com/saas/img/shop_itmbg.17c4984f.png";